import useMutationApi from '../useMutationApi';

interface ReprocessEmailForQuoteSheetRequest {
  quoteSheetId: string;
}

interface ReprocessEmailForQuoteSheetResponse {
  success: boolean;
  quoteSheetId?: string;
  extractionResultId?: string;
  lineItemsCreated?: number;
  error?: string;
}

export function useReprocessEmailForQuoteSheet({
  onSuccess,
}: {
  onSuccess?: (data: ReprocessEmailForQuoteSheetResponse) => void;
} = {}) {
  return useMutationApi<
    ReprocessEmailForQuoteSheetRequest,
    ReprocessEmailForQuoteSheetResponse
  >({
    endpoint: 'accounts-payable/quote-sheet-matching/reprocess-email',
    method: 'POST',
    successMessage: 'Email reprocessing started',
    errorMessage: 'Failed to reprocess email',
    showSuccessToast: true,
    showErrorToast: true,
    options: {
      onSuccess: (data) => {
        onSuccess?.(data.data);
      },
    },
  });
}
